import {useState} from 'react';
import {useWorkspace} from '../workspace/WorkspaceContext';
import {api} from '../api';
import {SettingsAction} from '../types';
import {errorMessage} from '../errors';
import {toast} from '../components/ui/sonner';

export function useWorkspaceSettings() {
  const {refresh, tickets, docs, setSelected} = useWorkspace();
  const [confirm, setConfirm] = useState<SettingsAction>(null);
  const [busy, setBusy] = useState(false);
  const hasSamples = tickets.some(ticket => ticket.is_sample) || docs.some(doc => doc.is_sample);
  async function perform(): Promise<void> {
    if (!confirm) return;
    setBusy(true);
    try {
      if (confirm === 'samples') {
        await api('/samples', {method: 'DELETE'}); setSelected(null); await refresh(); toast.success('Sample data cleared'); setConfirm(null);
      } else {
        await api('/session', {method: 'DELETE'}); window.location.assign('/');
      }
    } catch (error: unknown) { toast.error(errorMessage(error)); }
    finally { setBusy(false); }
  }
  return {confirm, setConfirm, busy, hasSamples, perform};
}
export type WorkspaceSettingsController = ReturnType<typeof useWorkspaceSettings>;